<div class="particle-task-checklist-container m-b-40 flex flex-col full-grow-no-shrink-no-basis">
  <div class="header-area flex flex-row justify-start items-center">
    <!--    <button (click)="addChecklist()"
                *ngIf="!checklists || checklists.length<1"
                [disabled]="!hasOwnerAndManagerPermission || !this.canEditCheckList()" class="link-button"
                mat-button>Add Checklist
        </button>-->
    <div class="title"><i class="fal fa-tasks"></i> Checklist</div>
    <!--    <circle-progress-->
    <!--      [animationDuration]="300"-->
    <!--      [animation]="true"-->
    <!--      [innerStrokeColor]="'#85a8e1'"-->
    <!--      [innerStrokeWidth]="4"-->
    <!--      [outerStrokeColor]="'#337aee'"-->
    <!--      [outerStrokeWidth]="8"-->
    <!--      [percent]="overallProgressNumber"-->
    <!--      [radius]="40"-->
    <!--      [showSubtitle]="false"-->
    <!--    ></circle-progress>-->
  </div>
  <div class="full-grow-no-shrink-no-basis">
    <div #checkItemDiv *ngFor="let checklist of checklists" class="checklist">
      <div *ngIf="!checklist.isEditing" class="section-header flex flex-row justify-start items-center">
        <div class="flex flex-row justify-start items-center">
          <div *ngIf="checklist.items?.length > 0" class="checkbox-div flex flex-row justify-start items-center">
            <mat-checkbox attr.data-cy="all-checklist-clear"
                          data-copilot="checklist-select-all"
                          [checked]="checklist?.checkedItemCount === checklist.items?.length"
                          (change)="onCheckAll($event, checklist)">
            </mat-checkbox>
          </div>
          <button data-cy="more_vert" [disabled]="!this.canEditCheckList()" *ngIf="checklists.length > 1"
                  [matMenuTriggerFor]="checklistActionsMenu" class="checklist-actions-button"
                  mat-icon-button>
            <mat-icon class="s-20">more_vert</mat-icon>
          </button>

          <mat-menu #checklistActionsMenu="matMenu">
            <button data-cy="Remove Checklist" (click)="removeChecklist(checklist)"
                    [disabled]="!hasOwnerAndManagerPermission" mat-menu-item>
              <span>Remove Checklist</span>
            </button>
            <button data-cy="Move Up" (click)="moveChecklist(checklist, +1)"
                    [disabled]="!hasOwnerAndManagerPermission || checklists.length <= 1 "
                    mat-menu-item>
              <span>Move Up</span>
            </button>
            <button data-cy="Move Down" (click)="moveChecklist(checklist, -1)"
                    [disabled]="!hasOwnerAndManagerPermission || checklists.length <= 1"
                    mat-menu-item>
              <span>Move Down</span>
            </button>
          </mat-menu>

        </div>
        <strong attr.data-cy="{{checklist.title}}"
                class="section-title pointer hide full-grow-no-shrink-no-basis">{{checklist.title}}</strong>

      </div>
      <!-- renaming checklist title -->
      <particle-inplace-input (cancelled)='resetEditing()'
                              (valueChanged)="checklistTitleChanged(checklist, $event)"
                              *ngIf="checklist.isEditing"
                              [disabled]="!hasOwnerAndManagerPermission"
                              [text]="checklist.title"
                              placeHolder="Title"
      ></particle-inplace-input>

      <div class="section-content">
        <div *ngIf="checklist.items.length" class="checklist-progress flex flex-row justify-start items-center">
          <span class="checklist-progress-value m-r-10 hide">
                                  {{+checklist.progress || 0}}%
          </span>
          <mat-progress-bar attr.data-cy="{{100 * checklist.checkedItemCount / checklist.items.length}}"
                            class="mat-accent checklist-progressbar" mode="determinate"
                            value="{{100 * checklist.checkedItemCount / checklist.items.length}}">
          </mat-progress-bar>
        </div>
        <div class="check-items">
          <div *ngFor="let checkItem of checklist.items" class="check-item flex flex-row">
            <div class="checkbox-div flex flex-row justify-start items-center">
              <mat-checkbox attr.data-cy="{{checkItem.title}}"
                            [attr.data-copilot]="'checklist-item-' + checkItem.title"
                            (change)="updateCheckedState(checklist, checkItem, $event)"
                            [(ngModel)]="checkItem.isCompleted"
                            [aria-label]="checkItem.title" [disabled]="!hasOwnerManagerAssigneeAndReviewerPermission">
              </mat-checkbox>
            </div>
            <div *ngIf="!checkItem.isEditing"
                 class="check-item-content flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
              <a attr.data-cy="{{checkItem.taskInfo.displayId}}" (click)="openChecklistItemSubTask(checkItem)"
                 *ngIf="checkItem.taskInfo">{{checkItem.taskInfo.displayId}}</a>
              <particle-task-checklist-item-attachment
                *ngIf="checkItem.type== 'Attachment'"
                [disabled]="!hasOwnerManagerAssigneeAndReviewerPermission"
                [checklistItem]="checkItem"
                [task]="dynamicData.card"
              ></particle-task-checklist-item-attachment>
              <div *ngIf="checkItem.type === 'Link'">
                <a attr.data-cy="{{checkItem.checklistItemLink?.displayText}}"
                   (click)=openLink(checkItem.checklistItemLink?.url)>{{checkItem.checklistItemLink?.displayText}}</a>
              </div>
              <label attr.data-cy="{{checkItem.title}}" matTooltip="{{checkItem.title}}"
                     (click)="startEditItem(checkItem)" [ngClass]="checkItem.isCompleted ? 'line-through' : ''"
                     class="full-grow-no-shrink-no-basis">{{checkItem.title}}</label>
              <div class="on-hover">
                <button data-cy="more_vert" [disabled]="!this.canEditCheckList()"
                        [matMenuTriggerFor]="checklistActionsMenu" class="checklist-actions-button"
                        mat-icon-button>
                  <mat-icon class="s-20">more_vert</mat-icon>
                </button>
                <mat-menu #checklistActionsMenu="matMenu">
                  <button data-cy="Remove Item" (click)="removeCheckItem(checklist, checkItem)"
                          [disabled]="!hasOwnerAndManagerPermission"
                          mat-menu-item>
                    <span>Remove Item</span>
                  </button>
                  <button data-cy="Convert to sub task" (click)="convertToSubTask(checklist, checkItem)"
                          *ngIf="checkItem.type==='Text' && card && !card.parentTicket"
                          [disabled]="!hasOwnerAndManagerPermission"
                          mat-menu-item>
                    <span>Convert to sub task</span>
                  </button>
                  <button data-cy="Convert to attachment" (click)="convertToAttachment(checklist, checkItem)"
                          *ngIf="checkItem.type==='Text'" [disabled]="!hasOwnerAndManagerPermission"
                          mat-menu-item>
                    <span>Convert to attachment</span>
                  </button>
                  <button data-cy="Convert to link" (click)="convertToLink(checklist, checkItem)"
                          *ngIf="checkItem.type==='Text'" [disabled]="!hasOwnerAndManagerPermission"
                          mat-menu-item>
                    <span>Convert to link</span>
                  </button>
                  <button data-cy="Add attachment" (click)="addAttachment(checklist, checkItem)"
                          *ngIf="checkItem.type==='Attachment'"
                          [disabled]="!hasOwnerAndManagerPermission"
                          mat-menu-item>
                    <span>Add attachment</span>
                  </button>
                  <button data-cy="Add Link" (click)="convertToLink(checklist, checkItem)"
                          *ngIf="checkItem.type==='Link'" [disabled]="!hasOwnerAndManagerPermission"
                          mat-menu-item>
                    <span>Add Link</span>
                  </button>
                  <button data-cy="Move Up" (click)="moveCheckItem(checklist, checkItem, +1)"
                          [disabled]="!hasOwnerAndManagerPermission || checklist.items.length <= 1"
                          mat-menu-item>
                    <span>Move Up</span>
                  </button>
                  <button data-cy="Move Down" (click)="moveCheckItem(checklist, checkItem, -1)"
                          [disabled]="!hasOwnerAndManagerPermission || checklist.items.length <= 1"
                          mat-menu-item>
                    <span>Move Down</span>
                  </button>
                </mat-menu>
              </div>
            </div>
            <particle-inplace-input
              (cancelled)='resetEditing()'
              (valueChanged)="updateChecklistItem(checklist, checkItem, $event)"
              *ngIf="checkItem.isEditing"
              [disabled]="!hasOwnerAndManagerPermission"
              [text]="checkItem.title"
              placeHolder="Title"
            ></particle-inplace-input>
          </div>
        </div>
        <div class="footer-toolbar">
          <button data-cy="Add Item" [disabled]="!canEditCheckList() || !hasOwnerAndManagerPermission"
                  (click)="addItem(checklist)" *ngIf="!checklist.isAddingNewItem"
                  class="light-background-button" mat-button>
            Add Item
          </button>
          <particle-inplace-input (cancelled)='resetEditing()'
                                  (valueChanged)="addItemToChecklist(checklist, $event)"
                                  *ngIf="checklist.isAddingNewItem"
                                  [disabled]="!hasOwnerAndManagerPermission"
                                  placeHolder="Title"
                                  text=""
          ></particle-inplace-input>
        </div>
      </div>
    </div>
  </div>
  <section class="footer-section"
           [ngClass]="{'hide':!isFolded}"
           *ngIf="data && data.currentPlatformLink && data.currentPlatformLink.rightPanel && saveCommand">
    <button [disabled]="saveCommand?.isDisabled" data-cy="Save" mat-button class="save-changes"
            (click)="saveAsPlatformLink()">
      <i class="fas fa-check"></i> {{saveCommand?.title}}
    </button>
  </section>
</div>


